<template>
  <div class="multi-select-calendar">
    <Calendar
      :attributes="calendarAttributes"
      borderless
      transparent
      @dayclick="onDayClick"
    />
    <p class="small text-muted mt-2 mb-0">
      日付をクリックして選択（複数可・同じ日をもう一度クリックで解除）
    </p>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { Calendar } from 'v-calendar'
import dayjs from 'dayjs'

const props = defineProps({
  modelValue: {
    type: [Array, String, Date],
    default: () => []
  }
})

const emit = defineEmits(['change', 'update:modelValue'])

const selectedYmd = ref([])

function normalizeModel (val) {
  if (val == null) return []
  if (Array.isArray(val)) {
    return val.map((d) => (typeof d === 'string' ? d : dayjs(d).format('YYYY-MM-DD')))
  }
  return []
}

watch(() => props.modelValue, (v) => {
  selectedYmd.value = normalizeModel(v)
}, { immediate: true, deep: true })

const calendarAttributes = computed(() => {
  if (!selectedYmd.value.length) return []
  return [{
    key: 'copy-dest',
    dates: selectedYmd.value,
    highlight: {
      color: 'blue',
      fillMode: 'solid'
    }
  }]
})

function onDayClick (day) {
  const ymd = dayjs(day.noonDate).format('YYYY-MM-DD')
  const i = selectedYmd.value.indexOf(ymd)
  if (i === -1) {
    selectedYmd.value = [...selectedYmd.value, ymd].sort()
  } else {
    selectedYmd.value = selectedYmd.value.filter((_, j) => j !== i)
  }
  const next = [...selectedYmd.value]
  emit('change', next)
  emit('update:modelValue', next)
}
</script>

<style scoped>
.multi-select-calendar {
  width: 100%;
}

.multi-select-calendar :deep(.vc-container) {
  width: 100%;
  max-width: 100%;
}
</style>
